<template>
	<div>
		<div class="empty-img" v-if="data.length==0">
      <img src="./notes.png"/>
      <p>暂无笔记</p>
    </div>
		<div class="me-note" v-dt-infinite-scroll="getData">
			<ul class="me-note-items">
				<!--<li class="me-note-item">
					<div class="me-note-title o1">《如何做出良好的设计？？？？？？？？？？》</div>
					<div class="me-note-from o1">源自：第2章·01节土壤对水资源对文化的影响</div>
					<div class="me-note-text o2">如何做出良好的设计如何做出良好的设计如何做出良好的设计如何做出良好的设计如何做出良好的设计如何做出良好的设计如何做出良好的设计</div>
					<div class="me-note-close">×</div>
				</li>-->
				<li class="me-note-item" v-for="(item,index) in data">
					<div class="me-note-title o1" @click="toNote(item.id)">{{item.title}}</div>
					<div class="me-note-from o1" @click="toNote(item.id)">源自：{{item.chapter}}·{{item.section}}土壤对水资源对文化的影响</div>
					<div class="me-note-text o2" @click="toNote(item.id)">{{tools.removeHTML(item.content)}}</div>
					<div class="me-note-close" @click="deleteNote(index)">×</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:[]
			}
		},
		methods:{
			toNote(id){
				this.$router.push("/note/"+id);
			},
			getData(page){
				return new Promise((resolve,reject)=>{
					this.$api.get("",{
						api:"/v1/my/myNote",
						user_type:this.tools.getStorage("user_type"),
						page,
						len:10
					},res=>{
						var data=res.data;
						this.data=this.data.concat(data);
						if(data.length<10){
							reject();
						}
						else{
							resolve();
						}
					})
				})
			},
			deleteNote(index){
				var deleteItem=this.data[index];
				this.$messagebox.confirm("确认删除吗？").then(()=>{
					this.$api.get("",{
						api:"/v1/section_note/delete",
						user_type:this.tools.getStorage("user_type"),
						id:deleteItem.id
					},res=>{
						this.data.splice(index,1);
						this.$toast("删除成功！");
					});
				});
			}
		}
	}
</script>

<style>
	.me-note-items{
		padding-top:0.133rem;
	}
	.me-note-item{
		position: relative;
		padding:0.4rem 0;
		margin:0 0.4rem;
		border-bottom:1px solid #e6e6e6;
	}
	.me-note-title{
		width:8.533rem;
		font-size: 0.453rem;
		color:#333;
	}
	.me-note-from{
		margin-top:0.2rem;
		font-size: 0.346rem;
		color:#999;
	}
	.me-note-text{
		margin-top:0.4rem;
		font-size: 0.373rem;
		line-height:0.56rem;
		color:#666;
	}
	.me-note-text img{
		max-width: 100%!important;
	}
	.me-note-close{
		position: absolute;
		right:0.1rem;
		top:0.1rem;
		width:1rem;
		height:1rem;
		line-height: 1rem;
		font-size: 0.4rem;
		text-align: center;
		color:#ccc;
	}
</style>



// WEBPACK FOOTER //
// src/components/me-note/me-note.vue